// App.js
import { Auth } from './pages/auth';
import { Dashboard } from './layouts/dashboard';
import { useSelector } from 'react-redux';
import { Navigate, Route, Routes } from 'react-router-dom';
import QbCallback from './qb_callback';
import { ConfigProvider } from './hooks/useConfigs';

function App() {
  const user = useSelector((state) => state.user);

  const getDefaultDashboardRoute = () => {
    if (!user?.loggedIn) return '/auth/sign-in';
    return user.role === 'admin' ? '/dashboard/finance' : '/dashboard/client';
  };

  return (
    <ConfigProvider>
      <Routes>
        <Route
          path="/dashboard/*"
          element={user?.loggedIn ? <Dashboard /> : <Navigate to="/auth/sign-in" replace />}
        />
        <Route path="/auth/*" element={<Auth />} />
        <Route
          path="*"
          element={<Navigate to={getDefaultDashboardRoute()} replace />}
        />
        <Route path="/qb-callback" element={<QbCallback />} />
      </Routes>
    </ConfigProvider>
  );
}

export default App;